import React from 'react';
import { ThemeProvider as JSSThemeProvider } from 'react-jss';

const ThemeProvider = ({ styles, children }) => {
  return <JSSThemeProvider theme={styles ? styles : {}}>{children}</JSSThemeProvider>;
};

export default ThemeProvider;
